var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgArrowDsk3 = function SvgArrowDsk3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.499 12.525a1.5 1.5 0 101.002 2.828l-1.002-2.828zm129.656 2.763a1.5 1.5 0 00.694-2.005L125.951 1.14a1.5 1.5 0 10-2.698 1.31l5.242 10.795-10.794 5.243a1.5 1.5 0 101.311 2.698l12.143-5.898zm-128.654.065c20.96-7.427 75.928-17.851 127.508.003l.982-2.835c-52.42-18.145-108.12-7.57-129.492.004l1.002 2.828z",
    fill: "#000"
  })));
};
export default SvgArrowDsk3;